var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10001 17.3799C1.10001 16.9657 1.43579 16.6299 1.85001 16.6299H5.64623C6.06044 16.6299 6.39623 16.9657 6.39623 17.3799V23.446C6.39623 23.8602 6.06044 24.196 5.64623 24.196H1.85001C1.43579 24.196 1.10001 23.8602 1.10001 23.446V17.3799Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7453 20.4063C17.7453 19.9921 18.0811 19.6563 18.4953 19.6563H22.2915C22.7057 19.6563 23.0415 19.9921 23.0415 20.4063V23.4459C23.0415 23.8601 22.7057 24.1959 22.2915 24.1959H18.4953C18.0811 24.1959 17.7453 23.8601 17.7453 23.4459V20.4063Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42264 14.3535C9.42264 13.9393 9.75842 13.6035 10.1726 13.6035H13.9689C14.3831 13.6035 14.7189 13.9393 14.7189 14.3535V23.446C14.7189 23.8602 14.3831 24.196 13.9689 24.196H10.1726C9.75842 24.196 9.42264 23.8602 9.42264 23.446V14.3535Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9837 1.82674L14.2437 4.30335H16.3894C16.6312 4.29745 16.8518 4.44037 16.9453 4.66341C17.0387 4.88644 16.9859 5.14396 16.8121 5.31215L14.8419 7.24704L15.9335 9.75392C16.0321 9.98936 15.9694 10.2615 15.7776 10.43C15.5858 10.5985 15.3078 10.6256 15.0871 10.4974L12.4491 9.01346L9.81104 10.4974C9.59028 10.6256 9.31232 10.5985 9.12053 10.43C8.92874 10.2615 8.86599 9.98936 8.96465 9.75392L10.0532 7.24704L8.08599 5.30812C7.91223 5.13993 7.85938 4.88241 7.95283 4.65937C8.04628 4.43633 8.26692 4.29341 8.50867 4.29931H10.6584L11.9184 1.8227C12.022 1.62368 12.228 1.49915 12.4523 1.5C12.6766 1.50085 12.8817 1.62694 12.9837 1.82674Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.fe0a6def966718a27d95c3ccc6d252a9.svg";
export { ForwardRef as ReactComponent };